module.exports = __webpack_public_path__ + "img/database-files.bf5b6a7d.svg";